<template>
  <button
    :class="[icon === '' ? '' : 'use-smallscreen-icon']"
    :type="type"
    class="button-arrow btn btn-sm"
    v-on="$listeners"
  >
    <span>
      <slot></slot>
    </span>
    <i :class="icon" class="smallscreen-icon"></i>
    <i class="button-arrow-icon icon-arrow"></i>
  </button>
</template>

<script>
export default {
  name: 'ButtonArrow',
  props: {
    // if provided, the text provided by <slot> will be hidden and replaced with the icon on small screens.
    icon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'button',
      validator: (prop) => ['button', 'submit', 'reset'].includes(prop),
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/reused-components/button-arrow/ButtonArrow.vue